import ApiAI from "../../../gd/api/ai/ai";
import {AIChatProvider, AiChatType} from "../../../model2/ai/@const";
import AIChatContext from "../../../model2/ai/chat/context/context";


export default async function createNewAIChat(message: string, provider: AIChatProvider, context: AIChatContext | null, type: AiChatType, agentId: ID | null = null) {

    try {

        const params: any = {
            message     : message,
            name        : 'Test AI chat', // How generated name ??? Or manually added?
            provider    : provider,
            context     : context,
            type        : type,
            agentId     : agentId,
        }



        const response = await ApiAI.newAIChat(params).promise()

        return response
    } catch (e) {
        console.error(e)
    }


}
